module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "freelance-container"
  }, [_c('span', {
    staticClass: "freelance-heading"
  }, [_vm._v("Available 4 projects")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.contactFormSubmitted),
      expression: "!contactFormSubmitted"
    }]
  }, [_vm._v("\n    Seeing some collaboration potential? Let me know if you have any projects in mind.\n  ")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.contactFormSubmitted),
      expression: "contactFormSubmitted"
    }]
  }, [_vm._v("\n    Thank you for your inquiry, I will get back to you as soon as I can.\n  ")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitContactForm(_vm.email)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    class: {
      'blinker': _vm.email == ''
    },
    attrs: {
      "required": "",
      "type": "email",
      "placeholder": "Email address"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('glossy-button', {
    staticClass: "glossy-button",
    class: _vm.isValidEmail(_vm.email) && !_vm.contactFormSubmitted ? 'purple' : null,
    attrs: {
      "disabled": !_vm.isValidEmail(_vm.email) || _vm.contactFormSubmitted
    }
  }, [_vm._v("\n        " + _vm._s((!_vm.contactFormSubmitted) ? '📨' : '📫') + "\n      ")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1baeefe6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Freelance.vue
// module id = 41
// module chunks = 0